export interface ContractKey {
  key: string;
  title: string;
  description: string;
  country?: string;
  category:
    | "authorization"
    | "membership"
    | "device_registration"
    | "terms_service"
    | "upload_file"
    | "grid_contract"
    | "other";
}

// Contract key constants for direct import
// Estonia
export const EE_ORIGIN_CERT_APPLICATION =
  "ee_avaldus_partiolu_tunnistuste_konto_avamiseks";
export const EE_TYPE_CONDITIONS =
  "ee_paritolutunnistuste_kasutamise_tyuptingimused";
export const EE_AUTHORIZATION_APPLICATION =
  "ee_avaldus_partiolu_tunnistuste_konto_volituse_andmiseks";
export const EE_INVESTMENT_SUPPORT =
  "ee_kinnituskiri_investeeringutoetuse_saamise_mittesaamise_kohta";
export const EE_NETWORK_CONTRACT = "ee_vorguleping";
export const EE_DEVICE_REGISTRATION = "ee_seadme_registreerimise_vorm";
export const EE_SOLDERA_MEMBERSHIP = "ee_soldera_liikmeleping";
export const EE_ELERING_DATA = "ee_eleringi_andmed";

// Lithuania
export const LT_LITGRID_TERMS = "lt_litgrid_terms_service";
export const LT_DEVICE_REGISTRATION = "lt_device_registration";
export const LT_REQUEST_FOR_GO = "lt_request_for_go_contract";
export const LT_INSPECTION_REPORT = "lt_inspection_report";
export const LT_PROPERTY_LIMIT_SCHEME = "lt_property_limit_scheme";
export const LT_AUTHORIZATION_APPLICATION = "lt_authotization_application";
export const LT_SOLDERA_MEMBERSHIP = "lt_soldera_membership_agreement";
export const LT_POWER_OF_ATTORNEY = "lt_power_of_attorney";

// Latvia
export const LV_AUTHORIZATION_APPLICATION = "lv_authotization_application";
export const LV_AST_TERMS = "lv_ast_terms_and_service";
export const LV_SOLDERA_MEMBERSHIP = "lv_soldera_membership_agreement";
export const LV_ACCOUNT_HOLDER_REGISTRATION =
  "lv_account_holder_registration_form";
export const LV_ACCOUNT_HOLDER_REGISTRATION_AUTH =
  "lv_account_holder_registration_form_auth";
export const LV_PRODUCTION_DEVICE_REGISTRATION =
  "lv_production_device_registration_form";
export const LV_GRID_CONNECTION_SCHEME = "UF_lv_grid_connection_scheme";
export const LV_DEVICE_AUXILIARIES = "UF_lv_document_of_device_auxiliaries";
export const LV_POWER_OF_ATTORNEY = "UF_lv_power_of_attorney";

// Generic/International
export const EN_AUTHORIZATION_APPLICATION = "en_authorization_application";
export const EN_SOLDERA_MEMBERSHIP = "en_soldera_membership_agreement";
export const PL_AUTHORIZATION_APPLICATION = "pl_authorization_application";

// Estonia contract keys
export const EE_CONTRACT_KEYS: ContractKey[] = [
  {
    key: EE_ORIGIN_CERT_APPLICATION,
    title: "Origin Certificate Account Application",
    description: "Application for opening an origin certificate account",
    country: "EE",
    category: "authorization",
  },
  {
    key: EE_TYPE_CONDITIONS,
    title: "Type Conditions",
    description: "Terms and conditions for using origin certificates",
    country: "EE",
    category: "terms_service",
  },
  {
    key: EE_AUTHORIZATION_APPLICATION,
    title: "Authorization Application",
    description:
      "Application for granting authorization to origin certificate account",
    country: "EE",
    category: "authorization",
  },
  {
    key: EE_INVESTMENT_SUPPORT,
    title: "Investment Support Confirmation",
    description:
      "Confirmation letter regarding receiving/not receiving investment support",
    country: "EE",
    category: "other",
  },
  {
    key: EE_NETWORK_CONTRACT,
    title: "Network Contract",
    description: "Grid connection contract",
    country: "EE",
    category: "grid_contract",
  },
  {
    key: EE_DEVICE_REGISTRATION,
    title: "Device Registration Form",
    description: "Form for registering production device",
    country: "EE",
    category: "device_registration",
  },
  {
    key: EE_SOLDERA_MEMBERSHIP,
    title: "Soldera Platform Agreement",
    description: "Soldera Platform Agreement",
    country: "EE",
    category: "membership",
  },
  {
    key: EE_ELERING_DATA,
    title: "Elering Data",
    description: "Elering system data summary",
    country: "EE",
    category: "other",
  },
];

// Lithuania contract keys
export const LT_CONTRACT_KEYS: ContractKey[] = [
  {
    key: LT_LITGRID_TERMS,
    title: "Litgrid Terms of Service",
    description: "Terms of service for Litgrid",
    country: "LT",
    category: "terms_service",
  },
  {
    key: LT_DEVICE_REGISTRATION,
    title: "Device Registration",
    description: "Device registration form",
    country: "LT",
    category: "device_registration",
  },
  {
    key: LT_REQUEST_FOR_GO,
    title: "Request for GO Contract",
    description: "Request for guarantees of origin contract",
    country: "LT",
    category: "authorization",
  },
  {
    key: LT_INSPECTION_REPORT,
    title: "Inspection Report",
    description: "Technical inspection report",
    country: "LT",
    category: "upload_file",
  },
  {
    key: LT_PROPERTY_LIMIT_SCHEME,
    title: "Property Limit Scheme",
    description: "Property boundary scheme document",
    country: "LT",
    category: "upload_file",
  },
  {
    key: LT_AUTHORIZATION_APPLICATION,
    title: "Authorization Application",
    description: "Authorization application form",
    country: "LT",
    category: "authorization",
  },
  {
    key: LT_SOLDERA_MEMBERSHIP,
    title: "Soldera Platform Agreement",
    description: "Soldera Platform Agreement",
    country: "LT",
    category: "membership",
  },
  {
    key: LT_POWER_OF_ATTORNEY,
    title: "Power of Attorney",
    description: "Power of attorney document",
    country: "LT",
    category: "upload_file",
  },
];

// Latvia contract keys
export const LV_CONTRACT_KEYS: ContractKey[] = [
  {
    key: LV_AUTHORIZATION_APPLICATION,
    title: "Authorization Application",
    description: "Account authorization form",
    country: "LV",
    category: "authorization",
  },
  {
    key: LV_AST_TERMS,
    title: "AST Terms and Service",
    description: "AST terms and service agreement",
    country: "LV",
    category: "terms_service",
  },
  {
    key: LV_SOLDERA_MEMBERSHIP,
    title: "Soldera Platform Agreement",
    description: "Soldera Platform Agreement",
    country: "LV",
    category: "membership",
  },
  {
    key: LV_ACCOUNT_HOLDER_REGISTRATION,
    title: "Account Holder Registration Form",
    description: "Account holder registration form",
    country: "LV",
    category: "device_registration",
  },
  {
    key: LV_ACCOUNT_HOLDER_REGISTRATION_AUTH,
    title: "Account Holder Registration Form (Auth)",
    description: "Account holder registration form for authorization",
    country: "LV",
    category: "authorization",
  },
  {
    key: LV_PRODUCTION_DEVICE_REGISTRATION,
    title: "Production Device Registration Form",
    description: "New device application form",
    country: "LV",
    category: "device_registration",
  },
  {
    key: LV_GRID_CONNECTION_SCHEME,
    title: "Grid Connection Scheme",
    description: "Grid connection scheme document",
    country: "LV",
    category: "upload_file",
  },
  {
    key: LV_DEVICE_AUXILIARIES,
    title: "Document of Device Auxiliaries",
    description: "Device auxiliaries documentation",
    country: "LV",
    category: "upload_file",
  },
  {
    key: LV_POWER_OF_ATTORNEY,
    title: "Power of Attorney",
    description: "Power of attorney document",
    country: "LV",
    category: "upload_file",
  },
];

// Generic/International contract keys
export const GENERIC_CONTRACT_KEYS: ContractKey[] = [
  {
    key: EN_AUTHORIZATION_APPLICATION,
    title: "Authorization Application",
    description: "Generic authorization application",
    category: "authorization",
  },
  {
    key: EN_SOLDERA_MEMBERSHIP,
    title: "Soldera Platform Agreement",
    description: "Generic Soldera Platform Agreement",
    category: "membership",
  },
  {
    key: PL_AUTHORIZATION_APPLICATION,
    title: "Authorization Application",
    description: "Authorization application for Poland",
    country: "PL",
    category: "authorization",
  },
];

// All contract keys combined
export const ALL_CONTRACT_KEYS: ContractKey[] = [
  ...EE_CONTRACT_KEYS,
  ...LT_CONTRACT_KEYS,
  ...LV_CONTRACT_KEYS,
  ...GENERIC_CONTRACT_KEYS,
];

// Generic groupBy function
const groupByCategory = <T extends { category: string }>(items: T[]) =>
  items.reduce(
    (acc, item) => {
      (acc[item.category] ??= []).push(item);
      return acc;
    },
    {} as Record<string, T[]>
  );

// Contract keys grouped by category
export const CONTRACT_KEYS_BY_CATEGORY = groupByCategory(ALL_CONTRACT_KEYS);
